import React, { useEffect, useRef } from "react";

// SASS
import "./Part7.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import splashImg from "../../assets/img/splash.png";
import dropImg from "../../assets/img/droplet.png";

// FUNCTION EXPORT
export default function Part7({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "highlight text1" },
    { stepNumber: "2", height: null, description: "highlight text3" },
    { stepNumber: "3", height: null, description: "spacer" },
  ];

  // REFS
  const text1El = useRef(null);
  const text3El = useRef(null);
  const drop1El = useRef(null);
  const drop2El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.addClassOnEnter(drop1El.current, "moved", direction);
            setTimeout(() => {
              animate.addClassOnEnter(text1El.current, "highlight", direction);
              animate.addClassOnEnter(text1El.current, "shakeX", direction);
              animate.fadeOutOnEnter(drop1El.current, direction);
            }, 500);
            break;
          }
          case "2": {
            animate.addClassOnEnter(drop2El.current, "moved", direction);

            setTimeout(() => {
              animate.addClassOnEnter(text3El.current, "highlight", direction);
              animate.fadeOutOnEnter(drop2El.current, direction);
              animate.addClassOnEnter(text3El.current, "shakeX", direction);
            }, 500);

            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.removeClassOnExit(text1El.current, "highlight", direction);
            animate.removeClassOnExit(drop1El.current, "moved", direction);
            animate.removeClassOnExit(text1El.current, "shakeX", direction);
            animate.fadeInOnExit(drop1El.current, direction);
            break;
          }
          case "2": {
            animate.removeClassOnExit(text3El.current, "highlight", direction);
            animate.removeClassOnExit(drop2El.current, "moved", direction);
            animate.removeClassOnExit(text3El.current, "shakeX", direction);
            animate.fadeInOnExit(drop2El.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part7">
          <div className="splash-img">
            <img src={splashImg} alt="" className="img-fluid" />
          </div>
          <div className="text-box">
            <div className="text text-1" ref={text1El}>
              REMEMBER
            </div>
            <div className="text text-2">
              A disinfectant may not kill germs right away. It takes{" "}
            </div>
            <div className="text text-3" ref={text3El}>
              <div className="line"></div>
              <div className="time">TIME</div>
              <div className="line"></div>{" "}
            </div>
            <div className="text text-4">
              for germs to react with a disinfectant.
            </div>
          </div>
          <div className="droplet droplet-1" ref={drop1El}>
            <img src={dropImg} alt="" className="img-fluid" />
          </div>
          <div className="droplet droplet-2" ref={drop2El}>
            <img src={dropImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
